import orderBy from 'lodash/orderBy';
import type { IDashboard } from '~/mst/models/dashboard';
import { collectTags } from '~/utils/tags';
import type { IDashboardsModel } from './model';

export default (self: IDashboardsModel) => ({
  /** Unique, sorted pool of tags authored in the descriptions of these dashboards. */
  get tags(): string[] {
    return collectTags(self.toArray.map((dashboard: IDashboard) => dashboard.description));
  },
  get list() {
    const pairs = self.filteredModels
      .map((dashboard: IDashboard) => dashboard.valueLabelPair)
      .sort(({ label: label1 }, { label: label2 }) => label1?.localeCompare(label2));
    return orderBy(pairs, ({ model }) => model.isStarred, ['desc']);
  }
});
